import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';
import { type HTMLMotionProps, motion } from 'framer-motion';

import { type LotteryTicketType } from '@/common/types/lottery';
import { StringMain, StringSmall } from '@/components/Typography/Typography';
import { TicketIcon } from '@/components/ui/TicketIcon/TicketIcon';

import css from './styles.module.scss';

const ticketVariants = cva('', {
  variants: {
    variant: {
      border: css.ticketItemBorder,
      fill: css.ticketItemFill,
    },
  },
});

interface TicketItemProps
  extends VariantProps<typeof ticketVariants>,
    HTMLMotionProps<'div'> {
  ticket: number | string;
  ticketType: LotteryTicketType;
}

const TicketItem: FC<TicketItemProps> = ({
  ticket,
  ticketType,
  variant = 'border',
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <motion.div
      {...props}
      className={cn(css.ticketItem, ticketVariants({ variant }))}
    >
      <div className="flex items-center gap-[8px]">
        <TicketIcon type={ticketType} className="size-[24px] shrink-0" />
        <StringSmall className="!text-[14px] !text-white/60">
          {t('Ticket ID')}
        </StringSmall>
      </div>
      <StringMain weight="bold" className="tracking-[3px] !leading-none">
        {ticket}
      </StringMain>
    </motion.div>
  );
};

export { TicketItem };
